var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complianceTips"},[_vm._v(_vm._s(_vm.text || _vm.$t('complianceTips')))])
}
var staticRenderFns = []

export { render, staticRenderFns }